export default "__VITE_ASSET__D4NvJ9FM__"